import {
  Button,
  Form,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from 'reactstrap'
import FormSchemaValidations from './schema-validations'
import FormBase from './form-base'
import { FormProvider, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { setOpenModal, checkIfUserExists, addUserAction } from '../store'
import { useDispatch, useSelector } from 'react-redux'
import toast from 'react-hot-toast'
import { createProducts } from '../thunks'

const Create = () => {
  const dispatch = useDispatch()
  const { modal } = useSelector((state) => state.productServiceMaster)

  const {
    handleSubmit,
    control,
    reset,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      type_of_entity: '',
      type_of_establishment: '',
      main_admin_name: '',
      main_admin_email: '',
    },
    mode: 'all',
    reValidateMode: 'onChange',
    resolver: yupResolver(FormSchemaValidations),
  })

  const onSubmit = async (data) => {
    if (checkIfUserExists(data.productCode)) {
      toast.error('Ya existe un registro con este código')
      return
    }
    const newProduct = await dispatch(
      createProducts({
        ...data,
        //prodTypeId: 1,
        quantity: 100, // solo aplica para facturas
        prodTypeId: data.prodType?.id,
        unitOfMeasureId: data.unitOfMeasure.id,
        typeOfSale: 'retail', // solo aplica para facturas
        discount: 1.0, // solo aplica para facturas
        accept: true, // solo aplica para facturas
      })
    )
    dispatch(addUserAction(newProduct))
    toast.success('Registro creado')
    handleClose()
  }
  const handleClose = () => {
    dispatch(setOpenModal({ type: 'create', open: false }))
  }

  return (
    <Modal
      isOpen={modal.create.open}
      toggle={handleClose}
      className="modal-dialog-centered modal-lg"
    >
      <ModalHeader
        className="bg-transparent"
        toggle={handleClose}
      ></ModalHeader>

      <FormProvider
        {...{
          handleSubmit,
          control,
          reset,
          setValue,
          formState: { errors },
        }}
      >
        <Form onSubmit={handleSubmit(onSubmit)}>
          <ModalBody>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <h1>Crear</h1>
            </div>
            <FormBase />
            <div>
              <p>Campos obligatorios (*)</p>
            </div>
          </ModalBody>

          <ModalFooter className={'d-flex justify-content-center'}>
            <Button
              color="primary"
              type="submit"
            >
              Guardar
            </Button>
            <Button
              type="reset"
              color="secondary"
              outline
              onClick={() => handleClose(false)}
            >
              Cancelar
            </Button>
          </ModalFooter>
        </Form>
      </FormProvider>
    </Modal>
  )
}

export default Create
